import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
  H1,
} from '../../../components/StyledComponents';

import React from 'react';
import RetailBg from '../../../assets/v2/png/retail_hero.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import RetailBgMobile from '../../../assets/v2/png/retail_mobile.jpg';
import { navigate } from 'gatsby';
import { Title } from '../HomePage/HomepageSectionOne';

// const ImgItem = styled(LazyLoadImage)`
//   width: 100%;
//   margin-left: -10%;
//   margin-top: 3.5rem;
//   @media (min-width: 800px) and (max-width: 1100px) {
//     height: 80%;
//   }
//   @media (max-width: 1100px) {
//     height: fit-content;
//     width: fit-content;
//   }
//   @media (max-width: 768px) {
//     margin-top: 0rem;
//     /* width: calc(100%); */
//     height: 80%;
//     margin-left: 1rem;
//   }
//   @media (max-width: 520px) {
//     margin-left: 0.5rem;
//     width: calc(100%);
//     height: 80%;
//   }
// `;

const BlueButtonNew = styled(BlueButton)`
  margin-left: 3.5rem;
  @media (max-width: 520px) {
    margin-left: 1rem;
  }
`;
const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 6rem !important;
  padding-bottom: 5rem;
  background: url(${RetailBg});
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    line-height: 1.4;
    background: url(${RetailBgMobile});
    background-size: cover;
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const SectionItemContainer = styled.div`
  /* grid-template-columns: repeat(3, 1fr); */
  /* padding: 10rem; */
  padding-bottom: 0rem;
  display: grid;
  text-align: center;
  @media (max-width: 1024px) {
    padding: 5rem;
  }
  @media (max-width: 768px) {
    padding: 0;
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  line-height: 1.15;
  color: #ffffff;
  text-align: center;
  margin-top: 14rem;
  max-width: 66rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 5rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-left: 0;
  }
`;

const GridRight = styled.div`
  grid-column: span 3;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
    padding-right: 0rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 1;
  padding-left: 7rem;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-left: 0;
    justify-self: center;
  }
  @media (max-width: 520px) {
    width: 80%;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  /* margin-left: 3rem; */
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  max-width: 64rem;
  text-align: center;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    line-height: 1.14;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  margin-left: 2rem;
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: -0.5rem;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

export default class RetailSectionOne extends React.Component<any, any> {
  render() {
    return (
      <div>
        <SectionOne>
          <SectionOneTitle>
            Retail Industry’s Most Robust Device Management Solution
          </SectionOneTitle>
          <HeroSubTitle style={{ paddingTop: '1rem' }}>
            Esper Manage is an Android device management platform that helps
            retailers deploy, manage and monitor the modern retail experience
            through touch-enabled devices such as kiosks, self checkout, digital
            signage, POS systems, customer feedback devices, and more.
          </HeroSubTitle>
          <BlueButtonWrapper>
            <BlueButtonNew
              id="retail__start_free_trial"
              onClick={() => navigate('/signup')}
            >
              Start free Trial
            </BlueButtonNew>
          </BlueButtonWrapper>
        </SectionOne>
      </div>
    );
  }
}
